import React from "react";
import { Box, Tab, Tabs } from "@mui/material";
import EntityAbout from "../../../shared/Entity/EntityAbout";
import EntityEndorsedSkills from "../../../shared/Entity/EntityEndorsedSkills";
import EntityOverview from "../../../shared/Entity/EntityOverview";
import {
  Certificate,
  EntityInfo,
  EndorsedSkill,
  UserInfo,
} from "../../../types";
import EntityCertificates from "../../../shared/Entity/EntityCertifcates";
import typography from "../../../theme/typography";
import { colors } from "../../../theme/palette";
import NetworkController from "../../../shared/NetworkController";
import { useTranslation } from "react-i18next";
import { LoadingTabs } from "../../Entity/Components/EntityTabs";
import { getUserData } from "../../../utils/userDataFormatter";

interface CustomTabPanelProps {
  children: React.ReactNode;
  value: number;
  index: number;
}

const a11yProps = (index: number) => ({
  id: `simple-tab-${index}`,
  "aria-controls": `simple-tabpanel-${index}`,
});

const CustomTabPanel: React.FC<CustomTabPanelProps> = ({
  children,
  value,
  index,
  ...other
}) => (
  <Box
    role="tabpanel"
    hidden={value !== index}
    id={`simple-tabpanel-${index}`}
    aria-labelledby={`simple-tab-${index}`}
    {...other}
  >
    {value === index && (
      <Box sx={{ display: "flex", flexDirection: "column", gap: "10px" }}>
        {children}
      </Box>
    )}
  </Box>
);

const EntityTabs = ({
  tabValue,
  handleChangeTabValue,
  entityInfo,
  skills,
  certificates,
  endorsementNumber,
  isLoading,
}: {
  tabValue: number;
  handleChangeTabValue: (event: React.SyntheticEvent, newValue: number) => void;
  entityInfo?: UserInfo;
  skills: EndorsedSkill[];
  endorsementNumber: number;
  certificates: Certificate[];
  isLoading: boolean;
}) => {
  const { about, overview, countriesWorkedIn } = getUserData(entityInfo);
  const { t } = useTranslation();

  return (
    <>
      {isLoading ? (
        <LoadingTabs />
      ) : (
        <Box
          sx={{
            display: "flex",
            padding: "12px 24px 0",
            backgroundColor: colors.White,
            border: "1px solid #EAECF0",
            borderRadius: "8px",
          }}
        >
          <Tabs
            value={tabValue}
            onChange={handleChangeTabValue}
            aria-label="entity tabs"
            sx={{
              minHeight: "unset",
              background: colors.White,
              "& .MuiTabs-flexContainer": {
                gap: "16px",
              },
              "& .MuiTabs-indicator": {
                height: "3px",
              },
            }}
          >
            <Tab
              label={t("pages.entity.home")}
              {...a11yProps(0)}
              sx={{
                padding: "0 0 8px",
                minHeight: "unset",
                minWidth: "unset",
                ...typography.body14Regular,
                textTransform: "capitalize",
                fontWeight: 600,
              }}
            />
            <Tab
              label={t("pages.entity.network")}
              {...a11yProps(1)}
              sx={{
                padding: "0 0 8px",
                minHeight: "unset",
                minWidth: "unset",
                ...typography.body14Regular,
                textTransform: "capitalize",
                fontWeight: 600,
              }}
            />
          </Tabs>
        </Box>
      )}
      <CustomTabPanel value={tabValue} index={0}>
        <EntityAbout text={about || ""} title="Agent" isLoading={isLoading} />
        <EntityOverview
          entityName="Agent"
          cards={overview || []}
          //  @ts-ignore
          countries={countriesWorkedIn || []}
          isLoading={isLoading}
        />
        <EntityEndorsedSkills
          skills={skills}
          endorsementNumber={endorsementNumber}
          isLoading={isLoading}
        />
        <EntityCertificates certificates={certificates} isLoading={isLoading} />
      </CustomTabPanel>

      <CustomTabPanel value={tabValue} index={1}>
        <Box
          sx={{
            background: colors.White,
            border: "1px solid #EAECF0",
            borderRadius: "8px",
            padding: "5px 16px",
          }}
        >
          <NetworkController />
        </Box>
      </CustomTabPanel>
    </>
  );
};
export default EntityTabs;
